import Cookies from 'js-cookie';

import {
  buildViewContentEvent,
  mapConsentToSignals,
  mintEventId,
  pushViewContent,
  readClickIds
} from './dataLayer';
import { sendCapiEvent } from '@lib/api/capi-shim';
import { ConsentManager } from '@lib/consent';

/**
 * FFH-606 — fire a View Content event on BOTH rails (Pattern A). Mints ONE
 * event_id shared by the dataLayer push (read by the GTM pixel) and the CAPI
 * shim, so the two rails dedup on a single id. Upper-funnel, so no value.
 *
 * Idempotent: once per browser-tab session — a landing-page re-render or
 * back-nav re-mount must not re-fire and inflate View Content volume.
 *
 * Fail-soft: an analytics failure must never break the page.
 */
export const fireViewContent = (params?: {
  email?: string;
  externalId?: string;
}): void => {
  if (typeof window === 'undefined') return;

  try {
    const idempotencyKey = 'ffh_view_content';
    if (window.sessionStorage.getItem(idempotencyKey)) return;
    window.sessionStorage.setItem(idempotencyKey, 'true');
  } catch {
    // Storage unavailable (private mode / webview) — proceed without the guard.
  }

  try {
    const eventId = mintEventId();
    const consent = mapConsentToSignals(
      new ConsentManager().getCurrentConsent()
    );
    const sourceUrl = window.location.href;

    pushViewContent(
      buildViewContentEvent({
        eventId,
        email: params?.email,
        externalId: params?.externalId ?? Cookies.get('_aid'),
        click: readClickIds(),
        sourceUrl,
        referrer: document.referrer || undefined,
        consent
      })
    );

    void sendCapiEvent({
      eventName: 'view_content',
      eventId,
      sourceUrl,
      consent
    });
  } catch {
    // Swallow — analytics must never break the page.
  }
};
